import React from 'react';
import styles from './Layout.module.css';
import { useTranslation } from 'react-i18next';

function Layout({ children }) {
  const { t } = useTranslation();

  return (
    <div className={styles.layout}>
      <div className={styles.content}>
        <h1>{t('layout.title')}</h1>
        <p className={styles.description}>
          {t('layout.description')}
        </p>
        
        {children}
        
        <div className={styles.landingContent}>
          <section className={styles.features}>
            <div className={styles.featureCard}>
              <h2>{t('landing.features.calculator.title')}</h2>
              <p>{t('landing.features.calculator.description')}</p>
            </div>
            <div className={styles.featureCard}>
              <h2>{t('landing.features.monthly.title')}</h2>
              <p>{t('landing.features.monthly.description')}</p>
            </div>
            <div className={styles.featureCard}>
              <h2>{t('landing.features.apy.title')}</h2>
              <p>{t('landing.features.apy.description')}</p>
            </div>
          </section>

          <section className={styles.benefits}>
            <h2>{t('landing.benefits.title')}</h2>
            <div className={styles.benefitsList}>
              {[1, 2, 3, 4].map((num) => (
                <div key={num} className={styles.benefitItem}>
                  <h3>{t(`landing.benefits.item${num}.title`)}</h3>
                  <p>{t(`landing.benefits.item${num}.description`)}</p>
                </div>
              ))}
            </div>
          </section>

          <section className={styles.faq}>
            <h2>{t('landing.faq.title')}</h2>
            <div className={styles.faqList}>
              {[1, 2, 3, 4, 5].map((num) => (
                <div key={num} className={styles.faqItem}>
                  <h3>{t(`landing.faq.q${num}`)}</h3>
                  <p>{t(`landing.faq.a${num}`)}</p>
                </div>
              ))}
            </div>
          </section>

          <section className={styles.security}>
            <h2>{t('landing.security.title')}</h2>
            <div className={styles.securityGrid}>
              {[1, 2, 3].map((num) => (
                <div key={num} className={styles.securityItem}>
                  <div className={styles.securityIcon}>
                    {t(`landing.security.item${num}.icon`)}
                  </div>
                  <h3>{t(`landing.security.item${num}.title`)}</h3>
                  <p>{t(`landing.security.item${num}.description`)}</p>
                </div>
              ))}
            </div>
          </section>

          <section className={styles.policies}>
            <div className={styles.policyGrid}>
              <div className={styles.policyCard}>
                <h3>{t('landing.policies.privacy.title')}</h3>
                <p>{t('landing.policies.privacy.description')}</p>
                <ul>
                  {[1, 2, 3].map((num) => (
                    <li key={num}>{t(`landing.policies.privacy.points.${num}`)}</li>
                  ))}
                </ul>
              </div>
              <div className={styles.policyCard}>
                <h3>{t('landing.policies.terms.title')}</h3>
                <p>{t('landing.policies.terms.description')}</p>
                <ul>
                  {[1, 2, 3].map((num) => (
                    <li key={num}>{t(`landing.policies.terms.points.${num}`)}</li>
                  ))}
                </ul>
              </div>
            </div>
          </section>

          <footer className={styles.footer}>
            <div className={styles.footerContent}>
              <div className={styles.footerSection}>
                <h3>{t('landing.footer.about.title')}</h3>
                <p>{t('landing.footer.about.description')}</p>
              </div>
              
              <div className={styles.footerSection}>
                <h3>{t('landing.footer.friendlyLinks.title')}</h3>
                <ul className={styles.friendlyLinks}>
                  {t('landing.footer.friendlyLinks.links', { returnObjects: true }).map((link, index) => (
                    <li key={index}>
                      <a href={link.url} target="_blank" rel="noopener noreferrer">
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className={styles.footerSection}>
                <h3>{t('landing.footer.contact.title')}</h3>
                <p>{t('landing.footer.contact.description')}</p>
                <p className={styles.emailContact}>
                  <span>{t('landing.footer.contact.email.label')}</span>
                  <a href={`mailto:${t('landing.footer.contact.email.address')}`}>
                    {t('landing.footer.contact.email.address')}
                  </a>
                </p>
              </div>
            </div>
            <div className={styles.footerBottom}>
              <p>{t('landing.footer.copyright')}</p>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
}

export default Layout; 